import * as React from 'react';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import InputContainer from 'src/modules/commons/inputs/input/Input.container';
import ErrorMessagesComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import Investment from 'src/entities/Investment';
import NumberFormater from 'src/services/number-formater/NumberFormater.service';
import Project from 'src/entities/Project';
import './ChangeAmount.scss';

export interface ChangeAmountComponentProps {
  handleSubmit: () => void;
  handleIsCorrect: () => void;
  handleChange: (key: string) => ((value: string | boolean | File) => void);
  modalRef?: Modal;
  errorMessages: {};
  error: string;
  message: string;
  investment: Investment;
  project: Project;
}

const ChangeAmountComponent: React.StatelessComponent<ChangeAmountComponentProps> =
  (props: ChangeAmountComponentProps) => {
    const investedValue = NumberFormater
      .euros(props.investment.amountInvested);

    const feeValue = NumberFormater
      .euros(1.21 * (props.investment.fees * 0.01) * props.investment.amountInvested);

    const totalValue = NumberFormater
      .euros((1.21 * (props.investment.fees * 0.01) + 1) * props.investment.amountInvested);

    let equity = (props.investment.quantityTickets * props.project.sharePercentage).toString();
    
    equity = parseFloat(equity).toLocaleString('es-ES', {minimumFractionDigits: 4});

    const investDate = props.investment.createdAt!.format('DD-MM-YYYY');

    return (
      <div className="modal-content">
        <div className="modal-header">
          <p className="text-right">
        <span
          className="close-med pointer"
          onClick={() => props.modalRef!.modal('hide')}
        />
          </p>
          <span className="alerted-circle"/>
          <h4 className="text-center">
            <strong>
              ¡Antes de seguir!
              <br/>
              Revisa bien los datos.
            </strong>
          </h4>
        </div>

        <div className="modal-body">

          <div>
            A continuación te mostramos el compromiso que adquiriste el día
            <strong> {investDate}</strong>
            , también puedes revisar tu correo electrónico.
          </div>
          <div className="gap-30"/>

          <div className="row">
            <div className="col-md-6">
              {props.investment.quantityTickets > 0 ?
                <div className="icon-content border-bottom-dashed">
                  <img
                    alt="Euro"
                    className="icon"
                    src="/img/small-bag.png"
                  />
                  <p className="inline-block f-s-16">
                    Tickets comprometidos:<br/>
                    <strong>{props.investment.quantityTickets}</strong>
                  </p>
                </div>
                : null
              }
              {props.investment.quantityTickets > 0 ?
                <div className="gap-20"/> : null
              }
              <div className="icon-content border-bottom-dashed">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/small-bag.png"
                />
                <p className="inline-block f-s-16">
                  Capital comprometido:<br/>
                  <strong>{investedValue}</strong>
                </p>
              </div>
              <div className="gap-20"/>
            </div>
            <div className="col-md-6">
              <div className="icon-content border-bottom-dashed">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/small-bag.png"
                />
                <p className="inline-block f-s-16">
                  Participación en la empresa:<br/>
                  <strong>{equity} %</strong>
                </p>
              </div>
              <div className="gap-20"/>
              <div className="icon-content border-bottom-dashed">
                <img
                  alt="Euro"
                  className="icon"
                  src="/img/small-bag.png"
                />
                <p className="inline-block f-s-16">
                  Corretaje:<br/>
                  <strong>{feeValue}</strong>
                </p>
              </div>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row padding-20">
            <h4>Total: <strong>{totalValue}</strong></h4>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-secondary text-center"
              onClick={() => props.handleIsCorrect()}
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              Es correcto
            </button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();
              props.handleSubmit();
            }}
          >
            <div className="text-center">

              <div className="gap-30"/>
              <div className="text-left">
                <strong>¿No es correcto?</strong>
                <div className="gap-20"/>
                <div>
                  Por favor, indícanos cual es el compromiso que querías adquirir y la razón de la modificación.
                  El equipo de soporte al inversor se pondrá en contacto contigo para solventar esta incidencia.
                </div>
              </div>
              <div className="gap-20"/>
              <div className="col">
                <div className="md-input">
                  <InputContainer
                    label="¿Donde ha encontrado la duda?"
                    type="text"
                    placeholder=""
                    value={props.error}
                    onChange={props.handleChange('error')}
                  />
                </div>
              </div>
              <div className="gap-10"/>
              <div className="col">
                <InputContainer
                  label=" "
                  type="textarea"
                  placeholder="Mensaje..."
                  value={props.message}
                  required={false}
                  onChange={props.handleChange('message')}
                />
              </div>
            </div>
            <div className="gap-20"/>
            <ErrorMessagesComponent errorMessage={props.errorMessages}/>
            <div className="text-right">
              <button
                type="submit"
                className="btn btn-secondary text-right"
              >
                Actualizar
              </button>
              <div className="gap-20"/>
            </div>
          </form>
        </div>
      </div>
    );
  };

export default ChangeAmountComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/change-amount/ChangeAmount.component.tsx